export type GalleryItem = {
  id: string;
  title: string;
  theme: string;
  photographer: string;
  uploadDate: string;
  photoCount: number;
  cover: string;
  images: string[];
  description: string;
  tags: string[];
};

export const galleryThemes = [
  "全部",
  "性感写真",
  "艺术人像",
  "光影质感",
  "黑白胶片",
  "复古胶片",
  "私房光影",
];

const img1 =
  "https://readdy.ai/api/search-image?query=Artistic%20silhouette%20of%20a%20woman%20in%20a%20long%20flowing%20dress%20against%20warm%20amber%20backlight%2C%20dark%20background%2C%20elegant%20fashion%20editorial%2C%20tasteful%2C%20cinematic%2C%20high%20detail&width=600&height=800&seq=adult-gallery-01&orientation=portrait";
const img2 =
  "https://readdy.ai/api/search-image?query=Close%20up%20of%20black%20lace%20fabric%20and%20pearl%20necklace%20resting%20on%20dark%20velvet%2C%20warm%20amber%20light%2C%20elegant%20still%20life%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=adult-gallery-02&orientation=portrait";
const img3 =
  "https://readdy.ai/api/search-image?query=Artistic%20portrait%20of%20a%20woman%20from%20behind%20with%20soft%20rim%20light%2C%20long%20hair%2C%20dark%20burgundy%20background%2C%20tasteful%20fashion%20editorial%2C%20cinematic%2C%20high%20detail&width=600&height=800&seq=adult-gallery-03&orientation=portrait";
const img4 =
  "https://readdy.ai/api/search-image?query=High%20contrast%20black%20and%20white%20artistic%20photograph%20of%20shadow%20patterns%20across%20draped%20fabric%2C%20minimal%20elegant%20composition%2C%20fine%20art%20photography%2C%20high%20detail&width=600&height=800&seq=adult-gallery-04&orientation=portrait";
const img5 =
  "https://readdy.ai/api/search-image?query=Vintage%20vanity%20mirror%20framed%20with%20warm%20bulbs%20in%20a%20dark%20room%2C%20burgundy%20tones%2C%20cinematic%20still%20life%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=600&height=800&seq=adult-gallery-05&orientation=portrait";
const img6 =
  "https://readdy.ai/api/search-image?query=Artistic%20photo%20of%20a%20bare%20shoulder%20silhouette%20behind%20sheer%20curtain%20with%20warm%20light%2C%20tasteful%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=adult-gallery-06&orientation=portrait";
const img7 =
  "https://readdy.ai/api/search-image?query=Dark%20botanical%20still%20life%20with%20deep%20red%20roses%20and%20thorns%20on%20black%20velvet%2C%20dramatic%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=adult-gallery-07&orientation=portrait";
const img8 =
  "https://readdy.ai/api/search-image?query=Silk%20bedsheets%20with%20warm%20morning%20light%20shadow%20stripes%2C%20minimal%20dark%20editorial%20interior%20photograph%2C%20burgundy%20and%20cream%20tones%2C%20high%20detail&width=600&height=800&seq=adult-gallery-08&orientation=portrait";
const img9 =
  "https://readdy.ai/api/search-image?query=Artistic%20close%20up%20of%20hands%20holding%20a%20glass%20of%20amber%20drink%20in%20dim%20candlelight%2C%20tasteful%2C%20cinematic%20still%20life%2C%20warm%20shadows%2C%20high%20detail&width=600&height=800&seq=adult-gallery-09&orientation=portrait";
const img10 =
  "https://readdy.ai/api/search-image?query=Moody%20portrait%20of%20a%20woman%20in%20profile%20with%20warm%20amber%20side%20light%2C%20dark%20background%2C%20elegant%20tasteful%20fashion%20editorial%2C%20film%20grain%2C%20high%20detail&width=600&height=800&seq=adult-gallery-10&orientation=portrait";
const img11 =
  "https://readdy.ai/api/search-image?query=Draped%20satin%20fabric%20in%20deep%20wine%20red%20falling%20over%20a%20dark%20chair%2C%20warm%20directional%20light%2C%20artistic%20still%20life%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=adult-gallery-11&orientation=portrait";
const img12 =
  "https://readdy.ai/api/search-image?query=Vintage%20perfume%20bottle%20on%20a%20marble%20table%20in%20a%20dim%20room%20with%20red%20light%20accents%2C%20cinematic%20still%20life%2C%20high%20detail&width=600&height=800&seq=adult-gallery-12&orientation=portrait";
const img13 =
  "https://readdy.ai/api/search-image?query=Artistic%20photo%20of%20warm%20light%20passing%20through%20thin%20red%20curtain%20fabric%2C%20abstract%20texture%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=800&seq=adult-gallery-13&orientation=portrait";
const img14 =
  "https://readdy.ai/api/search-image?query=Dark%20elegant%20boudoir%20corner%20with%20antique%20chair%20and%20warm%20lamp%2C%20burgundy%20cushions%2C%20moody%20editorial%20interior%20photography%2C%20high%20detail&width=600&height=800&seq=adult-gallery-14&orientation=portrait";

export const galleries: GalleryItem[] = [
  {
    id: "g1",
    title: "丝绒与光",
    theme: "性感写真",
    photographer: "林述",
    uploadDate: "2026-09-26",
    photoCount: 24,
    cover: img1,
    images: [img1, img6, img13],
    description:
      "整套作品只用了两盏灯和一匹红丝绒。摄影师林述想让光线自己讲故事，人物始终留在边缘，留给观众一点想象的空间。",
    tags: ["丝绒", "暖光", "人像"],
  },
  {
    id: "g2",
    title: "蕾丝与珍珠",
    theme: "艺术人像",
    photographer: "沈一",
    uploadDate: "2026-09-18",
    photoCount: 18,
    cover: img2,
    images: [img2, img9, img12],
    description:
      "静物与人像交替出现的双线结构。蕾丝、珍珠、玻璃杯，这些细小的物件被放大之后，反而比人物更接近情绪本身。",
    tags: ["静物", "细节", "质感"],
  },
  {
    id: "g3",
    title: "背光",
    theme: "光影质感",
    photographer: "陈屿",
    uploadDate: "2026-09-10",
    photoCount: 21,
    cover: img3,
    images: [img3, img10, img6],
    description:
      "全部采用逆光拍摄，轮廓线取代了面容。摄影师说，这组照片想讨论的是“被看见”和“看不清”之间的距离。",
    tags: ["逆光", "轮廓", "暗调"],
  },
  {
    id: "g4",
    title: "影与褶",
    theme: "黑白胶片",
    photographer: "苏离",
    uploadDate: "2026-08-29",
    photoCount: 16,
    cover: img4,
    images: [img4, img13, img11],
    description:
      "用黑白胶片记录布料的褶皱与投影。没有人物出镜，却处处是身体的痕迹，是一组非常克制的高级感作品。",
    tags: ["黑白", "褶皱", "抽象"],
  },
  {
    id: "g5",
    title: "梳妆台",
    theme: "复古胶片",
    photographer: "何岸",
    uploadDate: "2026-08-15",
    photoCount: 20,
    cover: img5,
    images: [img5, img12, img9],
    description:
      "一间保留了上世纪八十年代陈设的房间，暖色灯泡、旧镜子和香水瓶。整组照片没有后期调色，只靠现场光完成。",
    tags: ["复古", "室内", "胶片"],
  },
  {
    id: "g6",
    title: "帷幕之后",
    theme: "私房光影",
    photographer: "阿岚",
    uploadDate: "2026-08-03",
    photoCount: 27,
    cover: img6,
    images: [img6, img8, img14],
    description:
      "薄纱、午后斜光、被风吹起的窗帘。阿岚的镜头一贯温柔，这组作品把私密空间拍得像一场很慢的呼吸。",
    tags: ["纱帘", "午后", "温柔"],
  },
  {
    id: "g7",
    title: "暗夜花园",
    theme: "艺术人像",
    photographer: "纪南",
    uploadDate: "2026-07-27",
    photoCount: 19,
    cover: img7,
    images: [img7, img11, img3],
    description:
      "玫瑰与荆棘的对照，暗红与黑的反复交替。作品灵感来自维多利亚时期的植物图鉴，每一张都像一页被压干的标本。",
    tags: ["植物", "暗红", "静物"],
  },
  {
    id: "g8",
    title: "清晨的褶皱",
    theme: "私房光影",
    photographer: "白榆",
    uploadDate: "2026-07-14",
    photoCount: 22,
    cover: img8,
    images: [img8, img14, img1],
    description:
      "清晨六点的光穿过百叶窗，在床单上留下规整的条纹。整组作品拍摄于同一个房间的同一个早晨，安静而完整。",
    tags: ["清晨", "光影", "室内"],
  },
];

export const featuredGalleries = galleries.slice(0, 4);